import { getSession } from '@/common/js/api'
import { isArray, timeout, deepCopy, applyKey } from '@/common/js/utils'

import cityData from '@/data/baidu/city_province'
import gategoryData from '@/data/baidu/app_categroy'
import newInterestData from '@/data/baidu/new_interests'

import { getAudience } from '@/api/baidu.model'

const defaultTargetParams = {
  audienceMode: 'NONE',
  district: 'NONE',
  age: '0',
  customAge: '0',
  sex: '0',
  ageMode: 'NONE',
  keywordsType: 'NONE',
  keywords: [],
  mult_app: [], // 已选的app数据
  keywordsExtend: '1',
  interestType: 'NONE',
  appType: 'all',
  app: [],
  device: '0',
  net: '0',
  lifeStage: '0',
  education: '0',
  autoExpansion: '0',
  excludeTrans: '0'
}

const localAudience = (accounts) => {
  console.log('accounts output: ', accounts)
  const local = deepCopy(accounts)
  return local.map((ret) => {
    ret.includes = []
    ret.excludes = []
    ret.audienceData = []
    return ret
  })
}

export default {
  data() {
    return {
      DATA: {
        cityData,
        gategoryData,
        interestData: newInterestData
      }
    }
  },
  methods: {
    // 切换定向
    setTargeter(index) {
      // if (this.editState && !index) {
      //   const targetings = getSession('targetings') || []
      //   this.targetPlan = targetings
      // }
      const item = this.targetPlan[index]
      this.show = false
      this.targetPlan.forEach((ret) => {
        this.$set(ret, 'check', false)
      }) // 清空原选中
      this.$set(item, 'check', true)
      timeout(50).then(() => {
        this.show = true
        if (this.$refs.targeting && this.$refs.targeting[0]) {
          // 选中人群包账号
          timeout(300).then(() => {
            this.$refs.targeting[0].selectCurrent()
          })
        }
      })
    },
    // 删除定向
    delTargeter(index) {
      const idx = this.targetPlan.findIndex((ret) => ret.check)
      const len = this.targetPlan.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个定向'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setTargeter(index - 1)
        else this.setTargeter(1)
      }
      this.targetPlan.splice(index, 1)
    },
    // 添加定向
    async appendTargeter(target) {
      const len = this.targetPlan.length
      if (isArray(target)) {
        if (target.length > 10 - len) {
          const idx = target.length - (10 - len)
          target.splice(-idx, idx)
        }
        // 选择定向
        target.map((ret, idx) => {
          const { targetingId, targetingName, targetingParamJson } = ret
          const defaultParam = Object.assign({}, deepCopy(defaultTargetParams), { data: deepCopy(this.DATA) })
          const targetingParam = Object.assign({}, defaultParam, targetingParamJson)
          // 参数解析
          this.handleTargetLogic(targetingParam)
          // 合并所有定向参数
          this.$set(target, idx, {
            targetingId: targetingId,
            targetingName: targetingName,
            targetingParam: targetingParam
          })
          return ret
        })
        this.targetPlan.push(...target)
        this.setTargeter(this.targetPlan.length - 1)
      } else {
        // 添加定向
        let targetingParam = deepCopy(this.curTarget)
        const defaultParam = Object.assign({}, deepCopy(defaultTargetParams), { data: deepCopy(this.DATA) })
        const accountParam = { retargeting_tags: deepCopy(localAudience(this.accounts)) } // 多账号选择模式
        // 平台限制
        if (this.isAndroid) Object.assign(accountParam, { device: '2', androidVersion: '0' })
        else Object.assign(accountParam, { device: '1', iosVersion: '0' })
        if (!targetingParam.retargeting_tags) {
          // 区分第一次自动加定向
          targetingParam = Object.assign({}, defaultParam, accountParam)
        }
        this.targetPlan.push({
          targetingId: '',
          targetingName: `定向包${len + 1}`,
          targetingParam: deepCopy(targetingParam)
        })
        this.setTargeter(this.targetPlan.length - 1)
      }
      this.$Spin.hide()
    },
    async handleTargetLogic(target) {
      const retargeting_tags = deepCopy(localAudience(this.accounts)) // 参数跨账号处理
      // 系统定向
      if (!target.district) await this.convertSystemTarget(target)
      const { region, app, newInterests, device, iosVersion, androidVersion, crowd, excludeCrowd } = target
      this.decompile(region, target.data.cityData)
      this.decompile(app, target.data.gategoryData)
      this.decompile(newInterests, target.data.interestData)

      retargeting_tags.map((ret) => {
        this.getAccountAudience(ret.id, ret, crowd, excludeCrowd)
      })
      target.retargeting_tags = retargeting_tags
      // 定向包
      if ((isArray(crowd) && crowd.length) || (isArray(excludeCrowd) && excludeCrowd.length)) {
        target.audienceMode = 'AUDIENCE'
      }
      // 操作平台
      if (this.isAndroid) {
        device !== '2' && (target.device = '2')
        iosVersion !== '0' && (target.iosVersion = '0')
      } else {
        device !== '1' && (target.device = '1')
        androidVersion !== '0' && (target.androidVersion = '0')
        target.appType !== 'all' && (target.appType = 'all')
      }
    },
    async convertSystemTarget(target) {
      let { app } = target
      const convertKey = [
        'region',
        'customAge',
        'age',
        'crowd',
        'excludeCrowd',
        'education',
        'iosVersion',
        'keywords',
        'androidVersion',
        'lifeStage',
        'newInterests'
      ]
      Promise.resolve((resolve) => {
        convertKey.forEach((key) => {
          target[key] = applyKey(target[key]) // 逗号值换成数组
        })
        // APP定向
        app = app && JSON.parse(app)
        if (app) {
          const { type, list, behavior } = app
          target.appType = type
          target.appBehavior = behavior.includes(4) && behavior.length === 1 ? 4 : behavior
          if (type === 'category') {
            this.$set(
              target,
              'app',
              list.map((ret) => ret.id)
            )
          } else if (type === 'custom') this.$set(target, 'mult_app', list)
        }
        resolve()
      })
    },
    getAccountAudience(id, item, crowd, excludeCrowd) {
      this.loading = true
      getAudience({
        ad_account_id: id
      }).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (isArray(data)) {
          const audienceData = data
            .filter((ret) => ret.groupStatus === 'finished')
            .map((ret) => {
              const item = {
                id: ret.groupId,
                name: ret.groupName,
                type: ret.groupTypeDesc
              }
              if (crowd.includes(item.id)) this.$set(item, 'select', 'include')
              if (excludeCrowd.includes(item.id)) this.$set(item, 'select', 'exclude')
              return item
            })
          const includes = audienceData.filter((ret) => ret.select === 'include')
          const excludes = audienceData.filter((ret) => ret.select === 'exclude')
          this.$set(item, 'includes', includes)
          this.$set(item, 'excludes', excludes)
          this.$set(item, 'audienceData', audienceData)
          this.$set(item, 'xhr', true)
        }
      })
    },
    targetNameChange(val) {
      const index = this.targetPlan.findIndex((ret) => ret.check)
      this.$set(this.targetPlan[index], 'targetingName', val)
    },
    checkTargeter() {
      const targets = deepCopy(this.targetPlan)
      const params = targets.map((ret) => {
        // const { action_tags, location_types, action_scene, action_days, action_intensity } = ret.targetingParam

        ret.targetingParam.audiences = ret.targetingParam.retargeting_tags.map((met) => {
          // 人群包定向参数
          return {
            account_id: met.id,
            retargeting_tags_include: isArray(met.includes) ? met.includes.map((m) => m.id) : [],
            retargeting_tags_exclude: isArray(met.excludes) ? met.excludes.map((m) => m.id) : []
          }
        })
        return ret
      })
      return params
    }
  }
}
